import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuService } from '../../../../../modules/src/lib/core/services/menu.service';
import { environment } from '../../../environments/environment';
import { FlagManager } from '../../../../../modules/src/lib/core/managers/flag.manager';
import { FlagEnum } from '../../../../../modules/src/lib/core/enums/flag.enum';
import { OrganizationManager } from '../../managers/organization.manager';
import { AuthService } from '@auth0/auth0-angular';
import { NavItemModel } from '../../../../../modules/src/lib/core/models/nav-item.model';
import { CalculationKeynameEnum } from '../../../../../../../common/src/enums/calculations/calculation-keyname.enum';
import {
  ClientQuestionnaireKeynameEnum,
} from '../../../../../../../common/src/enums/client-questionnaire/client-questionnaire-keyname.enum';
import { OrganizationPermissionEnum } from '../../../../../../../common/src/enums/organization-permission.enum';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: false,
})
export class SidebarComponent implements OnInit {

  pictureUrl: string;
  email: string;

  isClientQuestionnairesAvailable: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  isCalculationsAvailable: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private router: Router, public auth: AuthService, private route: ActivatedRoute, public menuService: MenuService, private flagManager: FlagManager, private readonly organizationManager: OrganizationManager) {
    this.menuService.menuItems = {
      '/': new NavItemModel('/'),
      '/mandates': new NavItemModel('/mandates'),
      '/mandates/create': new NavItemModel('/mandates/create'),
      '/clients': new NavItemModel('/clients'),
      '/clients/personal': new NavItemModel('/clients/personal'),
      '/clients/personal/create': new NavItemModel('/clients/personal/create'),
      '/clients/corporate': new NavItemModel('/clients/corporate'),
      '/clients/corporate/create': new NavItemModel('/clients/corporate/create'),
      '/settings/employees': new NavItemModel('/settings/employees'),
      '/settings/upgrade': new NavItemModel('/settings/upgrade'),
      '/settings/payment-methods': new NavItemModel('/settings/payment-methods'),
      '/account/general': new NavItemModel('/account/general'),
      '/account/security': new NavItemModel('/account/security'),
      '/account/notifications': new NavItemModel('/account/notifications'),
      '/organization/settings': new NavItemModel('/organization/settings'),
      '/organization/members': new NavItemModel('/organization/members'),
      '/organization/employees': new NavItemModel('/organization/employees'),
      '/organization/billing': new NavItemModel('/organization/billing'),

      // Calculations
      '/calculations': new NavItemModel('/calculations'),
      '/calculations/create': new NavItemModel('/calculations/create'),
      ['/calculations/' + CalculationKeynameEnum.Section84_1]: new NavItemModel('/calculations/' + CalculationKeynameEnum.Section84_1 + '/*'),
      ['/calculations/:calculationKeyname/:id']: new NavItemModel('/calculations/:calculationKeyname/:id'),
      ['/calculations/:calculationKeyname/:id/results']: new NavItemModel('/calculations/:calculationKeyname/:id/results'),
      ['/calculations/:calculationKeyname/:id/errors']: new NavItemModel('/calculations/:calculationKeyname/:id/errors'),

      // Questionnaires
      ['/client-questionnaires']: new NavItemModel('/client-questionnaires'),
      ['/client-questionnaires/create']: new NavItemModel('/client-questionnaires/create'),
      ['/client-questionnaires/' + ClientQuestionnaireKeynameEnum.QuebecTaxForm2023]: new NavItemModel('/client-questionnaires/' + ClientQuestionnaireKeynameEnum.QuebecTaxForm2023 + '/*'),
      ['/client-questionnaires/:questionnaireKeyname/:questionnaireId']: new NavItemModel('/client-questionnaires/:questionnaireId'),
    };
  }

  async isCalculationsListActive() {
    return this.flagManager.isActive(FlagEnum.CalculationsList);
  }

  async isCreateNewCalculationActive() {
    return this.flagManager.isActive(FlagEnum.CalculationsCreate);
  }

  async isClientQuestionnairesActive() {
    return this.flagManager.isActive(FlagEnum.ClientQuestionnaires);
  }

  async isCreateNewClientQuestionnairesActive() {
    return this.flagManager.isActive(FlagEnum.ClientQuestionnairesCreate);
  }

  async isClientQuestionnairesListActive() {
    return this.flagManager.isActive(FlagEnum.ClientQuestionnairesList);
  }

  ngOnInit(): void {
    this.router.events.subscribe((val) => {
      this.refresh();
    });

    this.refresh();
  }

  refresh() {
    this.auth.user$.subscribe(async user => {
      this.email = user.email;
      this.pictureUrl = user.picture;

      await this.onProbablyReady();
    });

    this.menuService.updateActiveMenu();
  }

  environment() {
    return environment.name;
  }

  public async onProbablyReady() {
    this.isClientQuestionnairesAvailable.next(this.flagManager.isActive(FlagEnum.ClientQuestionnaires) && await this.organizationManager.hasPermission(OrganizationPermissionEnum.isClientQuestionnaireAvailable));
    this.isCalculationsAvailable.next(this.flagManager.isActive(FlagEnum.Calculations) && (
      await this.organizationManager.hasPermission(OrganizationPermissionEnum.isSection841Available) ||
      await this.organizationManager.hasPermission(OrganizationPermissionEnum.isRolloverAvailable) ||
      await this.organizationManager.hasPermission(OrganizationPermissionEnum.isRRQAvailable) ||
      await this.organizationManager.hasPermission(OrganizationPermissionEnum.isSalaryDividendAvailable)||
      await this.organizationManager.hasPermission(OrganizationPermissionEnum.isRrspAvailable)
    ));

  }

  public getReturnUrl(): string {
    return window.location.protocol + '//' + window.location.hostname + (window.location.port ? (':' + window.location.port) : '') + '/logged-out';
  }
}
